module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$is('reservation-id')) ? _c('div', {
    staticClass: "field-reservation-id"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'reservation',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('h3', {
    staticClass: "reservation-number pm-text-highlight"
  }, [_vm._v("R" + _vm._s(_vm.item.number))])])], 1)]) : (_vm.$is('vehicle-info')) ? _c('div', {
    staticClass: "field-vehicle-info text-center"
  }, [_c('img', {
    staticClass: "vehicle-picture",
    attrs: {
      "src": _vm.item.vehicle.picture_external
    }
  }), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.vehicle.brand) + " " + _vm._s(_vm.item.vehicle.model))]), _c('vehicle-fields', {
    attrs: {
      "fieldName": 'vehicle-plate',
      "item": _vm.item.vehicle
    }
  })], 1) : (_vm.$is('vehicle-info-no-img')) ? _c('div', {
    staticClass: "field-vehicle-info text-center"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.vehicle.brand) + " " + _vm._s(_vm.item.vehicle.model))]), _c('vehicle-fields', {
    attrs: {
      "fieldName": 'vehicle-plate',
      "item": _vm.item.vehicle
    }
  })], 1) : (_vm.$is('reservation-start')) ? _c('div', {
    staticClass: "field-reservation-start"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start, 'DD MMM YYYY HH:mm')))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.end, "DD MMM YYYY HH:mm")))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateDifference(_vm.item.start, _vm.item.end)))])]) : (_vm.$is('reservation-start-end')) ? _c('div', {
    staticClass: "field-reservation-start"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.start, 'DD MMM HH:mm')))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.end, "DD MMM HH:mm")))])]) : (_vm.$is('reservation-bmode')) ? _c('div', {
    staticClass: "field-reservation-bmode"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.booking_mode))])]) : (_vm.$is('reservation-distance')) ? _c('div', {
    staticClass: "field-reservation-distance"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_c('span', {
    staticClass: "fa fa-tachometer"
  }), _c('span', [_vm._v("  " + _vm._s(Math.round(_vm.item.distance)) + _vm._s(_vm.configuration.locale.locale_distance_unit.value))])])]) : (_vm.$is('reservation-hours')) ? _c('div', {
    staticClass: "field-reservation-hours"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateDifference(_vm.item.start, _vm.item.end)))])]) : (_vm.$is('reservation-cost')) ? _c('div', {
    staticClass: "field-reservation-cost"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_c('span', {
    staticClass: "fa fa-money"
  }), _c('span', [_vm._v("  " + _vm._s(_vm.item.cost === null ? '--' : _vm.currency + _vm.item.cost))])])]) : (_vm.$is('reservation-status')) ? _c('div', {
    staticClass: "field-reservation-status"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.status))]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v("Billing: " + _vm._s(_vm.item.billing_status))]), (_vm.item.billing_status === 'UNCHARGEABLE') ? _c('div', {
    staticClass: "field-value"
  }, [_vm._v("Cancelled: " + _vm._s(_vm.item.canceled))]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31467adf!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/entity-fields/ReservationFields.vue
// module id = 2388
// module chunks = 1